var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OverlayWrapper, StyledLink } from './styles';
import { getLeftIcon, getRightIcon } from './utils';
var Link = function (props) {
  var _a = props.disabled,
    disabled = _a === void 0 ? false : _a,
    _b = props.size,
    size = _b === void 0 ? 'normal' : _b,
    _c = props.inverted,
    inverted = _c === void 0 ? false : _c,
    _d = props.underline,
    underline = _d === void 0 ? true : _d,
    children = props.children,
    role = props.role,
    icon = props.icon,
    as = props.as,
    _e = props.dataCyLabel,
    dataCyLabel = _e === void 0 ? 'link' : _e,
    _f = props.overlay,
    overlay = _f === void 0 ? false : _f,
    restOfProps = __rest(props, ["disabled", "size", "inverted", "underline", "children", "role", "icon", "as", "dataCyLabel", "overlay"]);
  var iconLeft = getLeftIcon(role, icon, size);
  var iconRight = getRightIcon(role, icon, size);
  return _jsxs(StyledLink, __assign({
    "data-role": role,
    "data-overlay": overlay,
    disabled: disabled,
    underline: underline,
    size: size,
    inverted: inverted,
    as: as,
    "data-cy-label": dataCyLabel,
    overlay: overlay
  }, restOfProps, {
    children: [iconLeft, children, iconRight]
  }));
};
Link.OverlayWrapper = OverlayWrapper;
export { Link };